import { AppSubscriptionProduct, PaddleProduct, PlanType } from '@expane/data'

export type { AppSubscriptionProduct, PaddleProduct, PlanType } from '@expane/data'

export const PADDLE_AMOUNT_COEFFICIENT = 100

export const calculateYearlySavings = (monthlyAmount: string, yearlyAmount: string): number => {
  const monthlyTotal = parseFloat(monthlyAmount) * 12
  const yearlyTotal = parseFloat(yearlyAmount)
  const savings = ((monthlyTotal - yearlyTotal) / monthlyTotal) * 100

  return Math.round(savings)
}

export const isPlanType = (value: string | unknown): value is PlanType =>
  Object.values(PlanType).includes(value as PlanType)

export const convertPaddleAmount = (amount: string): string => {
  const convertedAmount = (parseFloat(amount) / PADDLE_AMOUNT_COEFFICIENT).toFixed(2)

  return `$${convertedAmount}`
}

export const normalizeAppSubscriptionProducts = (
  products: PaddleProduct[] | undefined | null,
): AppSubscriptionProduct[] => {
  const normalizedProducts: AppSubscriptionProduct[] = []

  for (const product of products || []) {
    if (
      product.customData &&
      'planType' in product.customData &&
      isPlanType(product.customData.planType)
    ) {
      normalizedProducts.push({
        ...product,
        customData: {
          ...product.customData,
          planType: product.customData.planType as PlanType,
        },
      })
    }
  }

  return normalizedProducts.sort((a, b) => {
    const priceA = Number(a.prices[0].unitPrice.amount)
    const priceB = Number(b.prices[0].unitPrice.amount)

    if (!isNaN(priceA) && !isNaN(priceB)) return priceA - priceB
    return 0
  })
}

export const getMonthlyPrice = (appSubscriptionProduct: AppSubscriptionProduct) =>
  appSubscriptionProduct.prices.find(
    price => price.billingCycle?.interval === 'month' && price.billingCycle.frequency === 1,
  )

export const getYearlyPrice = (appSubscriptionProduct: AppSubscriptionProduct) =>
  appSubscriptionProduct.prices.find(
    price => price.billingCycle?.interval === 'year' && price.billingCycle.frequency === 1,
  )
